import { useSelector } from 'react-redux';
import { selectMachines } from '@reducers/machines';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';

const isDemoMachine = (m: Record<string, unknown>) => (m.demoMachineTypeId as number) > 0;

export const useTrackMachineLiveOpened = () => {
  const machines = useSelector(selectMachines) as Record<string, unknown>[];

  useTrackScreenOpened(TRACKING_EVENTS.MACHINE_LIVE, () => ({
    demoMachineCount: machines?.filter((m) => isDemoMachine(m)).length || 0,
    realMachineCountConnected: machines?.filter((m) => !isDemoMachine(m) && (m.machineStatus as Record<string, unknown>)?.isConnected).length || 0,
    realMachineCountNotConnected: machines?.filter((m) => !isDemoMachine(m) && !(m.machineStatus as Record<string, unknown>)?.isConnected).length || 0,
    totalMachineCount: machines?.length || 0,
  }));
};
